const isDev = process.env.NODE_ENV == 'development';

const DEFAULT_URL: string =
    location.search != null ? location.search.substring(1) : null;

const DEFAULT_PARAMS = new URL(document.location).searchParams;

let IsPageLoading: boolean = false;
function setIsPageLoading(isPageLoading: boolean) {
    if (IsPageLoading != isPageLoading) IsPageLoading = isPageLoading;
}

let pieces = DEFAULT_URL.split('|');
let fileName = pieces[pieces.length - 1];
let folderPath = DEFAULT_URL.replace(fileName);
const FILE_PATH = DEFAULT_URL;

const userStr = localStorage.getItem('user');
const CURRENT_USER = userStr ? JSON.parse(userStr) : {};

let url = FILE_PATH.split('?')[0];
const RelativePath = decodeURIComponent(url).replace(
    new RegExp('[|]', 'g'),
    '/'
);

document.title = RelativePath
    ? (process.env.NODE_ENV == 'development' ? '|DEV| ' : '') + RelativePath
    : 'SpareDox';

let PageMode: 'ReadOnly' | 'Add' | 'Update' = 'ReadOnly';
function setPageMode(pageMode: 'ReadOnly' | 'Add' | 'Update') {
    if (PageMode != pageMode) PageMode = pageMode;
}

let IsPageDirty: Boolean = false;
function setIsPageDirty(ispageDirty: boolean) {
    if (IsPageDirty != ispageDirty) {
        IsPageDirty = ispageDirty;
        if (ispageDirty && document.title.indexOf('*') < 0) {
            document.title = document.title + '*';
        }
    }
}

export {
    CURRENT_USER,
    DEFAULT_URL,
    FILE_PATH,
    RelativePath,
    PageMode,
    setPageMode,
    IsPageDirty,
    setIsPageDirty,
    isDev,
    IsPageLoading,
    setIsPageLoading
};



// WEBPACK FOOTER //
// ./demo/src/GlobalParams.js